var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLasuLoginLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 99,
    viewBox: "0 0 62 99",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M53.415 52.683C40.464 35.8615 14.3709 16.6096 42.4473 1.95625C43.4508 1.43206 43.0207 -0.0690121 41.8977 0.0024676C41.8977 0.0024676 -18.8668 0.788746 5.95993 39.9596C6.05551 40.1264 6.17499 40.2932 6.27056 40.46C6.34225 40.5791 6.41393 40.6744 6.48562 40.7936C18.8153 59.9263 47.4652 80.1789 22.065 96.7145C20.942 97.4531 21.611 99.2163 22.9252 98.978C51.8857 93.903 75.2548 79.5832 53.415 52.683ZM54.5858 73.2692C53.415 79.9883 47.2979 85.5399 36.4019 89.8286C45.458 77.82 33.9885 64.358 25.3147 54.3509C11.7903 38.8636 -5.82021 14.4175 24.8846 7.55549C25.482 7.41253 25.936 8.1035 25.6014 8.60386C10.476 30.5958 58.5763 51.8253 54.5858 73.2692Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLasuLoginLogo);
export default __webpack_public_path__ + "static/media/LasuLoginLogo.79e418be4053a142394d174522d97883.svg";
export { ForwardRef as ReactComponent };